import { createFileRoute, redirect } from '@tanstack/react-router';
import { first } from '@/app/searchSerialization';

/**
 * The retired Security page. Its MFA management moved to the Security tab of `/auth/profile`; this
 * route now only redirects inbound `/auth/security` links to `/auth/profile`, preserving any
 * `returnUrl` so links from sibling apps keep working until they migrate. No auth check is needed —
 * the profile route guards itself. `beforeLoad` redirects before any component mounts.
 */
export const Route = createFileRoute('/security')({
  validateSearch: (search: Record<string, unknown>): { returnUrl?: string } => ({
    returnUrl: first(search.returnUrl),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/profile',
      search: search.returnUrl ? { returnUrl: search.returnUrl } : {},
      replace: true,
    });
  },
});
